import { render, staticRenderFns } from "./Inner-banner.vue?vue&type=template&id=0ad0294a&scoped=true&"
import script from "./Inner-banner.vue?vue&type=script&lang=js&"
export * from "./Inner-banner.vue?vue&type=script&lang=js&"
import style0 from "./Inner-banner.vue?vue&type=style&index=0&id=0ad0294a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad0294a",
  null
  
)

export default component.exports